"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
var prop_types_1 = __importDefault(require("prop-types"));
var ads = [
    {
        name: 'Pre-roll',
        description: 'Upload een sponsor- partner- of promotievideo van maximaal 20 seconden, deze wordt afgespeeld voordat de video of livestream zelf begint.',
    },
    {
        name: 'Pre-roll',
        description: 'Upload een sponsor- partner- of promotievideo van maximaal 20 seconden, deze wordt afgespeeld voordat de video of livestream zelf begint.',
    },
    {
        name: 'Pre-roll',
        description: 'Upload een sponsor- partner- of promotievideo van maximaal 20 seconden, deze wordt afgespeeld voordat de video of livestream zelf begint.',
    },
];
function Ads(_a) {
    var user = _a.user, channel = _a.channel, id = _a.id;
    var videos = ra_fetch_1.useApi('backend').index('videos', {
        channel_id: channel.id,
        type: 'ads',
        status: ['published', 'draft'],
        resource: 'VideoFull',
    })[0];
    if (videos.loading) {
        return react_1.default.createElement(storybook_1.Icons.Icon, { name: 'loader' });
    }
    return react_1.default.createElement(storybook_1.Layouts.Container, { className: 'storybook-layouts-space' },
        react_1.default.createElement(storybook_1.Forms.Error, { type: 'info', className: 'mb-4' }, "We spelen e\u0301e\u0301n advertentie af voor iedere video. Dat wil zeggen dat wanneer je er 3 hebt geu\u0308pload, er steeds 1 willekeurig wordt afgespeeld, mits deze niet langer is dan 20 sec. We tonen deze ads alleen als de video zelf langer dan een minuut is."),
        react_1.default.createElement("div", { className: 'storybook-channels-branding' }, ads.map(function (ad, index) { return react_1.default.createElement(storybook_1.Channels.Ads, { channel: channel, key: index, video: videos.data[index] || {
                channel_id: id,
                type: 'ads',
                user_id: user.id,
            }, ad: ad, setUpload: function (upload) {
                //
            } }); })));
}
exports.default = Ads;
Ads.propTypes = {
    id: prop_types_1.default.number,
};
